import {types} from './types';

export function setMenu(data) {
  return {
    type: types.SET_MENU,
    payload: data,
  };
}
